import { Alert } from "@/components/ui/alert";
import type { Timesheet } from "@/api/Timesheet";
import { useI18n } from "@/i18n/I18nContext";
import { userService } from "@/service/UserService";
import { Stack, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";

const ApprovalDecisionDetails = ({ entry }: {
  entry: Pick<Timesheet, "decidedBy" | "decidedAt" | "decisionReason">;
}) => {
  const { t, language } = useI18n();
  const [decider, setDecider] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    setDecider(null);
    if (!entry.decidedBy) return;
    userService.find(entry.decidedBy)
      .then(user => { if (active) setDecider(`${user.firstName} ${user.lastName}`); })
      .catch(() => undefined);
    return () => { active = false; };
  }, [entry.decidedBy]);

  if (!entry.decidedAt && !entry.decidedBy && !entry.decisionReason) return null;

  return (
    <Stack gap="1" w="full">
      {decider && <Text fontSize="sm">{t("approvals.decidedBy", { name: decider })}</Text>}
      {entry.decidedAt && <Text fontSize="sm">{t("approvals.decidedAt", {
        date: new Date(entry.decidedAt).toLocaleString(language === "de" ? "de-CH" : "en-GB"),
      })}</Text>}
      {entry.decisionReason && <Alert status="warning" title={t("approvals.decisionReason")}>
        {entry.decisionReason}
      </Alert>}
    </Stack>
  );
};

export default ApprovalDecisionDetails;
